@if (jobs && showHideCareers && departments && departments.length > 0) {
  <div class="container">
    <div class="flex flex-col md:flex-row mx-auto">
      <div class="flex flex-col mb-auto py-v-spacing sm:px-v-spacing md:w-3/12 lg:w-4/12 w-full">
        <button
        class="
          careers__departments
          mb-v-spacing
          p-1
          border border-ace-teal-800
          hover:bg-ace-teal-600 hover:text-vis-reverse
          focus:outline-hidden
        "
          [class]="department === 'all' ? 'text-vis-reverse bg-ace-teal-600 ' : 'text-ace-teal-800'"
          (click)="department = 'all'"
          >
          All Teams
        </button>
        @for (dep of departments; track dep) {
          <button
        class="
          careers__departments
          mb-v-spacing
          p-1
          border border-ace-teal-800
          hover:bg-ace-teal-600 hover:text-vis-reverse
          focus:outline-hidden
        "
            [class]="department === dep ? 'text-vis-reverse bg-ace-teal-600 ' : 'text-ace-teal-800'"
            (click)="department = dep"
            >
            {{ dep }}
          </button>
        }
      </div>
      <div class="flex flex-col py-v-spacing sm:px-v-spacing md:w-9/12 lg:w-8/12 w-full">
        @for (job of data.greenhouse.jobs; track job) {
          <div class="careers__jobs">
            @if (department === 'all' || department === job.departments[0].name) {
              <div
                class="p-v-spacing mb-v-spacing bg-ace-grey-100"
                >
                @if (department === 'all' || department === job.departments[0].name) {
                  <a
                    class="text-ace-teal-800 text-md hover:text-ace-grey-800"
                    [attr.href]="job.absolute_url"
                    target="_blank"
                    >{{ job.title }}</a
                    >
                  }
                  <p class="mt-v-spacing">{{ job.location.name }}</p>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (!jobs || jobs.length === 0) {
    <div class="container">
      <div class="flex flex-col mx-auto justify-center justify-items-center">
        <h2 class="mx-auto">Career Openings</h2>
        <p class="text-vis-subtle mx-auto text-center">Unfortunately, we have no open roles at this time – but please check back in the future!</p>
      </div>
    </div>
  }

